export function hasKey(val, key) {
  return key in val;
}